import React from 'react';
import { Alert, Box, SpaceBetween } from '@cloudscape-design/components';
import { ClientSideTable } from 'src/components/ClientSideTable';

interface ErrorsByJobTableProps {
  errorMessages?: { jobId: string; jobType: string; errorMessages: string[] }[];
}

export const ErrorsByJobTable = ({ errorMessages }: ErrorsByJobTableProps) => {
  if (!errorMessages || errorMessages?.length === 0) return <></>;
  return (
    <Box margin={{ bottom: 'm' }}>
      <SpaceBetween size={'m'}>
        <Alert type="error" header="Data Quality Monitoring Error">
          <p>
            One or more of the jobs being monitored had an error saving the
            metrics data.
          </p>
        </Alert>
        <ClientSideTable
          data={errorMessages}
          columnDefinitions={[
            {
              id: 'jobId',
              header: 'Job Id',
              cell: (item) => item.jobId,
              width: 100,
            },
            {
              id: 'jobType',
              header: 'Job Type',
              cell: (item) => item.jobType,
              width: 75,
            },
            {
              id: 'errorMessages',
              header: 'Error Messages',
              cell: (item) => {
                return (
                  <ul className="list-disc list-inside">
                    {item.errorMessages.map(
                      (message: string, index: number) => {
                        return <li key={index}>{message}</li>;
                      },
                    )}
                  </ul>
                );
              },
            },
          ]}
          title="Error Messages by Job"
          error={null}
        />
      </SpaceBetween>
    </Box>
  );
};
